import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { useField } from 'formik';
import { IFormItem } from '../form-item.type';

interface ICheckbox extends IFormItem {
  id?: string;

  label?: string;

  value: string;

  checked?: boolean;

  placeholder?: string;

  className?: string;

  disabled?: boolean;
}

export function Checkbox({
  id,
  name,
  label = '',
  value = '',
  checked = false,
  disabled = false,
  className = '',
  onChange,
}: ICheckbox) {
  const [field] = useField(name);
  const [isChecked, setIsChecked] = useState<boolean>(checked || field.value === value);

  useEffect(() => {
    setIsChecked(Array.isArray(field.value) && field.value.includes(value));
  }, [field, value]);
  const handleChange = useCallback(
    (e) => {
      field.onChange(e);
      onChange && onChange(e);
      setIsChecked(e.target.checked);
    },
    [field, onChange]
  );

  const usedId = id || `${Math.random()}`;

  return (
    <>
      <div className='form-checkbox'>
        <input
          className={clsx('form-check-input', className)}
          type='checkbox'
          id={usedId}
          value={value}
          name={field.name}
          disabled={disabled}
          checked={isChecked}
          onChange={handleChange}
          onBlur={field.onBlur}
        />
        <label htmlFor={usedId} className='form-check-label'>
          {label}
        </label>
      </div>
    </>
  );
}
